<el-titulo>Prueba Entregada</el-titulo>

<div>Tu prueba fue entregada de forma satisfactoria. Se te informará tu resultado en un plazo máximo de 5 días.</div>
<div>
    <div>
        <button class="btn btn-primary" (click)="volver()">Volver a página principal</button>
    </div>
</div>
